import React from 'react'
import PropTypes from 'prop-types'
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
  DrawerFooter,
  DrawerClose
} from '../../ui/drawer'
import { Button } from '../../ui/button'
import MultiSelectDayDateTime from './MultiSelectDayDateTime/MultiSelectDayDateTime'

function ClassTimesDrawer({ open, onOpenChange, dates, onChange }) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Class Times</DrawerTitle>
          <DrawerDescription>
            Select the days and times when this class will meet. Classes can run on multiple days per week.
          </DrawerDescription>
        </DrawerHeader>

        <div className="flex-1 p-6 overflow-y-auto">
          <MultiSelectDayDateTime value={dates} onChange={onChange} />
        </div>

        <DrawerFooter className="border-t border-gray-200">
          <DrawerClose asChild>
            <Button variant="outline" className="w-full">
              Done
            </Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}

ClassTimesDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  dates: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default ClassTimesDrawer
